import React from 'react';
import styled from 'styled-components';

import Logo from '@images/logos/submittable-logo__color.svg';
import WhiteLogo from '@images/logos/submittable-logo__white.svg';
import Event from '@util/GAEvent';
import Link from '@util/link';

const LogoLink = styled(Link)`
	img {
		height: 35px;
	}
`;

const LogoImg = styled.img`
	height: 35px;
`;

export default ({ noLinkLogo, reverse }) =>
	noLinkLogo ? (
		<LogoImg
			className="logo"
			src={reverse ? WhiteLogo : Logo}
			alt="submittable link to home"
			title="Submittable Link to Home"
		/>
	) : (
		<LogoLink to="/">
			<Event action="Clicked Navbar Logo" label="/">
				<img
					className="logo"
					src={reverse ? WhiteLogo : Logo}
					alt="submittable link to home"
					title="Submittable Link to Home"
				/>
			</Event>
		</LogoLink>
	);
